import { ID } from "../types";
import { createRequest, prune } from "../../utils/utility";
import { Transaction } from "../transaction/types";
import { ValidationMessages } from "common/utils/types";
import { validateRequiredNotDefault, validateBooleansTrue, CustomValidationArguments, validateNumbersInRange } from "common/utils/validation";

export class Investment {
  id: ID = Investment.default().id;
  sale_id: ID = Investment.default().sale_id;
  amount: number = Investment.default().amount;
  minAmount: number = Investment.default().minAmount;
  maxAmount: number = Investment.default().maxAmount;
  paid: number = Investment.default().paid;
  propertyPrice: number = Investment.default().propertyPrice;
  currency: string = Investment.default().currency;
  termsEffectaGmbh: boolean = Investment.default().termsEffectaGmbh;
  termsFinproAG: boolean = Investment.default().termsFinproAG;
  agreement1: boolean = Investment.default().agreement1;
  agreement2: boolean = Investment.default().agreement2;
  payment: ID = Investment.default().payment;
  payment_id: ID = Investment.default().payment_id;
  revocable: boolean = Investment.default().revocable;
  status: string = Investment.default().status;
  token_id: ID = Investment.default().token_id;
  transactions: Transaction[] = Investment.default().transactions;
  user_id: ID = Investment.default().user_id;
  toBePaid: number = Investment.default().toBePaid;
  limitIncreased: boolean = Investment.default().limitIncreased;
  limitIncreasedBy: number = Investment.default().limitIncreasedBy;

  constructor(obj: any) {
    obj && Object.assign(this, prune(obj));

    this.toBePaid = Math.round(this.amount * this.propertyPrice);
  }

  static readonly addFields : Array<string> = [
    'sale_id',
    'amount',
    'currency',
    'payment',
    'termsEffectaGmbh',
    'termsFinproAG',
  ];

  static required(): any {
    return {
      id: false,
      sale_id: false,
      amount: true,
      minAmount: false,
      maxAmount: false,
      paid: false,
      propertyPrice: false,
      currency: false,
      termsEffectaGmbh: true,
      termsFinproAG: true,
      agreement1: true,
      agreement2: true,
      payment: true,
      payment_id: false,
      revocable: false,
      status: false,
      token_id: false,
      transactions: false,
      user_id: false,
      toBePaid: false,
      limitIncreased: false,
      limitIncreasedBy: false,
    } 
  }

  static default(): any {
    return {
      id: "",
      sale_id: "",
      amount: 0,
      minAmount: 0,
      maxAmount: null,
      paid: null,
      propertyPrice: 0,
      currency: "EUR",
      termsEffectaGmbh: false,
      termsFinproAG: false,
      agreement1: false,
      agreement2: false,
      payment: "",
      payment_id: "",
      revocable: false,
      status: "",
      token_id: "",
      transactions: [],
      user_id: "",
      toBePaid: null,
      limitIncreased: false,
      limitIncreasedBy: "",
    } 
  }

  validate(keys: Array<string>, messages: any): any {
    let errors: any = {};

    validateBooleansTrue(new CustomValidationArguments({
      keys: ['termsEffectaGmbh', 'termsFinproAG', 'agreement1', 'agreement2'],
      errors,
      values: this,
      allowedKeys: keys,
      errorMessage: messages[ValidationMessages.Required]
    }));

    validateRequiredNotDefault(
      errors,
      Investment.required(),
      this,
      Investment.default(),
      keys,
      messages[ValidationMessages.Required]
    );

    validateNumbersInRange(
      [{
        key: 'amount',
        min: this.minAmount,
        max: this.maxAmount,
      }],
      errors,
      this,
      keys,
      messages[ValidationMessages.Minimum],
      messages[ValidationMessages.Maximum],
    );

    return errors;
  }

  private createRequest(fields: Array<string>): any {
    return createRequest(this, fields);
  }

  addRequest(): any {
    return this.createRequest(Investment.addFields);
  }

  isRevocable(): boolean {
    return this.revocable && this.status !== "revoked";
  }
}
